import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogsPageRoutingModule } from './logs-page-routing.module';
import { LogsPageComponent } from './logs-page.component';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LogsPageComponent
  ],
  imports: [
    CommonModule,
    LogsPageRoutingModule,
    TableModule,
    CardModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    InputSwitchModule,
    AutoCompleteModule,
    FormsModule
  ]
})
export class LogsPageModule { }
